let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ggICi")).then(() => parcelRequire('a1wXB'));